export enum FormBuilderActionTypes {
    CHANGE_ISSORTING = '@@FormBuilder/CHANGE_ISSORTING',   
    CHANGE_ISCONDITIONALLY = '@@FormBuilder/CHANGE_ISCONDITIONALLY',   
    CHANGE_ISCHANGESHAXES = '@@FormBuilder/CHANGE_ISCHANGESHAXES',   
    CHANGE_SEARCH_VALUE = '@@FormBuilder/CHANGE_SEARCH_VALUE',
    CHANGE_FORMID = '@@FormBuilder/CHANGE_FORMID',
    CHANGE_FORMLIST = '@@FormBuilder/CHANGE_FORMLIST',
    CHANGE_ADDFORMLIST = '@@FormBuilder/CHANGE_ADDFORMLIST',
    CHANGE_EXPANDKEY = '@@FormBuilder/CHANGE_EXPANDKEY',   
    CHANGE_CURRENTFORM = '@@FormBuilder/CHANGE_CURRENTFORM',   
    CHANGE_FIELD = '@@FormBuilder/CHANGE_FIELD',   
    CHANGE_BOAD = '@@FormBuilder/CHANGE_BOAD',   
    CHANGE_SHAXES = '@@FormBuilder/CHANGE_SHAXES',   
    CHANGE_CONDOTION = '@@FormBuilder/CHANGE_CONDOTION',
    CHANGE_GROUPES = '@@FormBuilder/CHANGE_GROUPES',   
    CHANGE_CHARTTYPE = '@@FormBuilder/CHANGE_CHARTTYPE',       
    CHANGE_CHARTCOLORPALLET = '@@FormBuilder/CHANGE_CHARTCOLORPALLET',       
    CHANGE_CHART_DATA = '@@FormBuilder/CHART_DATA',   
    CHANGE_CHART_DRILL = '@@FormBuilder/CHART_DRILL',   
    CHANGE_CHART_DRILL_STEP = '@@FormBuilder/CHART_DRILL_STEP',   
    CHANGE_SHAXES_AGGREGATION = '@@FormBuilder/CHART_SHAXES_AGGREGATION',
    CHANGE_SHAXES_UNIQNAME= '@@FormBuilder/CHANGE_SHAXES_UNIQNAME',

    CHANGE_SHAXES_CALCULATETYPE = '@@FormBuilder/CHART_SHAXES_CALCULATETYPE',
    CHANGE_SHAXES_HEATMAPMODE = '@@FormBuilder/CHART_SHAXES_HEATMAPMODE',
    CHANGE_SHAXES_DESIGN = '@@FormBuilder/CHART_SHAXES_DESIGN',
    CHANGE_BOAD_FILTER = '@@FormBuilder/CHANGE_BOAD_FILTER',
    CHANGE_BOAD_SETTING = '@@FormBuilder/CHANGE_BOAD_SETTING',
    CHANGE_SHAXES_SORT = '@@FormBuilder/CHANGE_SHAXES_SORT',
    CHANGE_SHAXES_CONDITIONALLITY = '@@FormBuilder/CHANGE_SHAXES_CONDITIONALLITY',
    CHANGE_TABLE_CONDITIONALLITY = '@@FormBuilder/CHANGE_TABLE_CONDITIONALLITY',

    CHANGE_SHAXES_FILTER = '@@FormBuilder/CHANGE_SHAXES_FILTER',  
    CHANGE_CONDITION_FILTER = '@@FormBuilder/CHANGE_CONDITION_FILTER',
    
    CHANGE_BOAD_FILTERCRITERIA = '@@FormBuilder/CHANGE_BOAD_FILTERCRITERIA',  
    CHANGE_SHAXES_FILTERCRITERIA = '@@FormBuilder/CHANGE_SHAXES_FILTERCRITERIA',  
    CHANGE_CONDITION_FILTERCRITERIA = '@@FormBuilder/CHANGE_CONDITION_FILTERCRITERIA',  
    
    CHANGE_SHAXES_FILTERAGGREGATION = '@@FormBuilder/CHANGE_SHAXES_FILTERAGGREGATION',


    CHANGE_RESET_INITIAL_STATE = '@@FormBuilder/RESET_INITIAL_STATE',
    
    CHANGE_MAPTYPE = '@@FormBuilder/MAPTYPE',   
    CHANGE_GAUGETYPE = '@@FormBuilder/GAUGETYPE',   

    

    CHANGE_TESTAM = '@@FormBuilder/CHANGE_TESTAM',

    CHANGE_ACTIVEKEY_PUBLICSETTINGS = '@@FormBuilder/ACTIVEKEY_PUBLICSETTINGS',   

    CHANGE_CHART_PUBLIC='@@FormBuilder/CHANGE_CHART_PUBLIC',
    CHANGE_CHART_LEGEND = '@@FormBuilder/CHART_LEGEND',
      
    CHANGE_CHART_LABELONCHART = '@@FormBuilder/CHART_LABELONCHART',
    CHANGE_CHART_TABLESTYLE = '@@FormBuilder/CHART_TABLESTYLE',
    CHANGE_CHART_TOOLTIP = '@@FormBuilder/CHART_TOOLTIP',
    CHANGE_CHART_WIDGET= '@@FormBuilder/CHANGE_CHART_WIDGET',
    CHANGE_FORM_TABLENAME= '@@FormBuilder/CHANGE_FORM_TABLENAME',
    CHANGE_CHART_FUNNEL = '@@FormBuilder/CHART_FUNNEL',
    CHANGE_FORM_ROWNUMBER= '@@FormBuilder/CHANGE_FORM_ROWNUMBER',
    CHANGE_FORM_PUBLICSETTING= '@@FormBuilder/CHANGE_FORM_PUBLICSETTING',
    CHANGE_FORM_SUBFORM= '@@FormBuilder/CHANGE_FORM_SUBFORM',


    CHANGE_CHART_GAUGE= '@@FormBuilder/CHART_GAUGE',
    CHANGE_CHART_SCATTER= '@@FormBuilder/CHART_SCATTER',

    CHANGE_CHART_GRIDLINE = '@@FormBuilder/CHART_GRIDLINE',
    CHANGE_GET_CONDITIONALLITYLIST = '@@FormBuilder/GET_CONDITIONALLITYLIST',
    CHANGE_CONDITIONALLITY = '@@FormBuilder/CHANGE_CONDITIONALLITY',

}
